/**
 * Created by Ning Jiang on 2025-01-07.
 */

import {Emitter} from "pixi-particles";
import {ParticlesManager} from "../../../core/particles/ParticlesManager";
import {ElGordosRevenge} from "../../ElGordosRevenge";

export class BackgroundParticles extends PIXI.Container {

    public static KEY_NORMAL:string = "Normal";
    public static KEY_WIN:string = "Win";

    private _NORMAL_Normal_RightConfig:any = {
        "alpha" : {
            "start" : 0.8,
            "end" : 0.11
        },
        "scale" : {
            "start" : 0.5,
            "end" : 1,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 150,
            "end" : 100,
            "minimumSpeedMultiplier" : 1
        },
        "acceleration" : {
            "x" : 0,
            "y" : -20
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 270,
            "max" : 330
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 50,
            "max" : 150
        },
        "lifetime" : {
            "min" : 3.5,
            "max" : 6
        },
        "blendMode" : "normal",
        "frequency" : 0.12,
        "emitterLifetime" : -1,
        "maxParticles" : 100,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -200,
            "y" : 150,
            "w" : 800,
            "h" : 10
        }
    };
    private _NORMAL_Normal_LeftConfig:any = {
        "alpha" : {
            "start" : 0.8,
            "end" : 0.11
        },
        "scale" : {
            "start" : 0.5,
            "end" : 1,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 150,
            "end" : 100,
            "minimumSpeedMultiplier" : 1
        },
        "acceleration" : {
            "x" : 0,
            "y" : -20
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 270,
            "max" : 330
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 50,
            "max" : 150
        },
        "lifetime" : {
            "min" : 3.5,
            "max" : 6
        },
        "blendMode" : "normal",
        "frequency" : 0.18,
        "emitterLifetime" : -1,
        "maxParticles" : 100,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -820,
            "y" : 150,
            "w" : 500,
            "h" : 10
        }
    };
    private _NORMAL_Win_RightConfig:any = {
        "alpha" : {
            "start" : 0.8,
            "end" : 0.11
        },
        "scale" : {
            "start" : 0.5,
            "end" : 1,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 150,
            "end" : 160,
            "minimumSpeedMultiplier" : 1
        },
        "acceleration" : {
            "x" : 0,
            "y" : -40
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 260,
            "max" : 330
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 50,
            "max" : 200
        },
        "lifetime" : {
            "min" : 3.5,
            "max" : 6
        },
        "blendMode" : "normal",
        "frequency" : 0.04,
        "emitterLifetime" : -1,
        "maxParticles" : 100,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -300,
            "y" : 150,
            "w" : 900,
            "h" : 10
        }
    };
    private _NORMAL_Win_LeftConfig:any = {
        "alpha" : {
            "start" : 0.8,
            "end" : 0.11
        },
        "scale" : {
            "start" : 0.5,
            "end" : 1,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 150,
            "end" : 160,
            "minimumSpeedMultiplier" : 1
        },
        "acceleration" : {
            "x" : 0,
            "y" : -40
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 260,
            "max" : 330
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 50,
            "max" : 200
        },
        "lifetime" : {
            "min" : 3.5,
            "max" : 6
        },
        "blendMode" : "normal",
        "frequency" : 0.1,
        "emitterLifetime" : -1,
        "maxParticles" : 100,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -820,
            "y" : 150,
            "w" : 500,
            "h" : 10
        }
    };
    private _FREESPIN_Normal_RightConfig:any = {
        "alpha" : {
            "start" : 0.8,
            "end" : 0.11
        },
        "scale" : {
            "start" : 0.5,
            "end" : 1,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#f0ab7d",
            "end" : "#f0ab7d"
        },
        "speed" : {
            "start" : 150,
            "end" : 100,
            "minimumSpeedMultiplier" : 1
        },
        "acceleration" : {
            "x" : 0,
            "y" : -30
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 270,
            "max" : 330
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 50,
            "max" : 200
        },
        "lifetime" : {
            "min" : 3.5,
            "max" : 6
        },
        "blendMode" : "normal",
        "frequency" : 0.06,
        "emitterLifetime" : -1,
        "maxParticles" : 100,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -300,
            "y" : 150,
            "w" : 900,
            "h" : 10
        }
    };
    private _FREESPIN_Normal_LeftConfig:any = {
        "alpha" : {
            "start" : 0.8,
            "end" : 0.11
        },
        "scale" : {
            "start" : 0.5,
            "end" : 1,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#f0ab7d",
            "end" : "#f0ab7d"
        },
        "speed" : {
            "start" : 150,
            "end" : 100,
            "minimumSpeedMultiplier" : 1
        },
        "acceleration" : {
            "x" : 0,
            "y" : -30
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 270,
            "max" : 330
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 50,
            "max" : 200
        },
        "lifetime" : {
            "min" : 3.5,
            "max" : 6
        },
        "blendMode" : "normal",
        "frequency" : 0.12,
        "emitterLifetime" : -1,
        "maxParticles" : 100,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -920,
            "y" : 150,
            "w" : 600,
            "h" : 10
        }
    };
    private _FREESPIN_Win_RightConfig:any = {
        "alpha" : {
            "start" : 0.8,
            "end" : 0.11
        },
        "scale" : {
            "start" : 0.5,
            "end" : 1,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#f0ab7d",
            "end" : "#f0ab7d"
        },
        "speed" : {
            "start" : 150,
            "end" : 160,
            "minimumSpeedMultiplier" : 1
        },
        "acceleration" : {
            "x" : 0,
            "y" : -50
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 260,
            "max" : 330
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 50,
            "max" : 250
        },
        "lifetime" : {
            "min" : 3.5,
            "max" : 6
        },
        "blendMode" : "normal",
        "frequency" : 0.05,
        "emitterLifetime" : -1,
        "maxParticles" : 100,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -300,
            "y" : 150,
            "w" : 900,
            "h" : 10
        }
    };
    private _FREESPIN_Win_LeftConfig:any = {
        "alpha" : {
            "start" : 0.8,
            "end" : 0.11
        },
        "scale" : {
            "start" : 0.5,
            "end" : 1,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#f0ab7d",
            "end" : "#f0ab7d"
        },
        "speed" : {
            "start" : 150,
            "end" : 160,
            "minimumSpeedMultiplier" : 1
        },
        "acceleration" : {
            "x" : 0,
            "y" : -50
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 260,
            "max" : 330
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 50,
            "max" : 250
        },
        "lifetime" : {
            "min" : 3.5,
            "max" : 6
        },
        "blendMode" : "normal",
        "frequency" : 0.06,
        "emitterLifetime" : -1,
        "maxParticles" : 100,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -920,
            "y" : 150,
            "w" : 600,
            "h" : 10
        }
    };
    private _FREESPIN_SUPER_Normal_RightConfig:any = {
        "alpha" : {
            "start" : 1,
            "end" : 0.14
        },
        "scale" : {
            "start" : 0.5,
            "end" : 1,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#e85e0e",
            "end" : "#e85e0e"
        },
        "speed" : {
            "start" : 150,
            "end" : 100,
            "minimumSpeedMultiplier" : 1
        },
        "acceleration" : {
            "x" : 60,
            "y" : -30
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 280,
            "max" : 330
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 50,
            "max" : 200
        },
        "lifetime" : {
            "min" : 3.5,
            "max" : 6
        },
        "blendMode" : "normal",
        "frequency" : 0.04,
        "emitterLifetime" : -1,
        "maxParticles" : 100,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -200,
            "y" : 150,
            "w" : 800,
            "h" : 10
        }
    };
    private _FREESPIN_SUPER_Normal_LeftConfig:any = {
        "alpha" : {
            "start" : 1,
            "end" : 0.14
        },
        "scale" : {
            "start" : 0.5,
            "end" : 1,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#e85e0e",
            "end" : "#e85e0e"
        },
        "speed" : {
            "start" : 150,
            "end" : 100,
            "minimumSpeedMultiplier" : 1
        },
        "acceleration" : {
            "x" : 60,
            "y" : -30
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 280,
            "max" : 330
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 50,
            "max" : 200
        },
        "lifetime" : {
            "min" : 3.5,
            "max" : 6
        },
        "blendMode" : "normal",
        "frequency" : 0.08,
        "emitterLifetime" : -1,
        "maxParticles" : 100,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -820,
            "y" : 150,
            "w" : 500,
            "h" : 10
        }
    };
    private _FREESPIN_SUPER_Win_RightConfig:any = {
        "alpha" : {
            "start" : 1,
            "end" : 0.14
        },
        "scale" : {
            "start" : 0.5,
            "end" : 1,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#e85e0e",
            "end" : "#e85e0e"
        },
        "speed" : {
            "start" : 150,
            "end" : 160,
            "minimumSpeedMultiplier" : 1
        },
        "acceleration" : {
            "x" : 60,
            "y" : -50
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 280,
            "max" : 330
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 50,
            "max" : 250
        },
        "lifetime" : {
            "min" : 3.5,
            "max" : 6
        },
        "blendMode" : "normal",
        "frequency" : 0.03,
        "emitterLifetime" : -1,
        "maxParticles" : 100,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -200,
            "y" : 150,
            "w" : 800,
            "h" : 10
        }
    };
    private _FREESPIN_SUPER_Win_LeftConfig:any = {
        "alpha" : {
            "start" : 1,
            "end" : 0.14
        },
        "scale" : {
            "start" : 0.5,
            "end" : 1,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#e85e0e",
            "end" : "#e85e0e"
        },
        "speed" : {
            "start" : 150,
            "end" : 160,
            "minimumSpeedMultiplier" : 1
        },
        "acceleration" : {
            "x" : 60,
            "y" : -50
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 280,
            "max" : 330
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 50,
            "max" : 250
        },
        "lifetime" : {
            "min" : 3.5,
            "max" : 6
        },
        "blendMode" : "normal",
        "frequency" : 0.06,
        "emitterLifetime" : -1,
        "maxParticles" : 100,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -820,
            "y" : 150,
            "w" : 500,
            "h" : 10
        }
    };

    private _emitterRight:Emitter | null;
    private _emitterLeft:Emitter | null;
    private _currentKey:string;
    private _currentMode:string;

    constructor() {
        super();
    }

    public playLoop(mode:string, key:string):void {
        if(key === this._currentKey && mode === this._currentMode) {
            return;
        }
        this._currentKey = key;
        this._currentMode = mode;
        this.stopLoop();
        this._emitterRight = new Emitter(this, [
            ElGordosRevenge.assetLoader.getTextures("particles/spark_1")[0],
            ElGordosRevenge.assetLoader.getTextures("particles/spark_2")[0],
            ElGordosRevenge.assetLoader.getTextures("particles/spark_3")[0],
            ElGordosRevenge.assetLoader.getTextures("particles/spark_4")[0]
        ], (<any>this)[`_${mode}_${key}_RightConfig`]);
        this._emitterLeft = new Emitter(this, [
            ElGordosRevenge.assetLoader.getTextures("particles/spark_1")[0],
            ElGordosRevenge.assetLoader.getTextures("particles/spark_2")[0],
            ElGordosRevenge.assetLoader.getTextures("particles/spark_3")[0],
            ElGordosRevenge.assetLoader.getTextures("particles/spark_4")[0]
        ], (<any>this)[`_${mode}_${key}_LeftConfig`]);

        ParticlesManager.addEmitter(this._emitterRight);
        ParticlesManager.addEmitter(this._emitterLeft);
    }

    public stopLoop():void {
        if(this._emitterRight) {
            ParticlesManager.queueRemoveEmitter(this._emitterRight);
        }
        if(this._emitterLeft) {
            ParticlesManager.queueRemoveEmitter(this._emitterLeft);
        }
        this._emitterRight = null;
        this._emitterLeft = null;
    }
}